import React from 'react';
import { Button, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { useNavigate } from 'react-router-dom';
import { siteConfig } from '../../config/site';

import '../../App.css';

const TOPIC_CARDS = [
  {
    key: 'career',
    title: '事业篇',
    desc: '重点看职业路径、跳槽去留、搞钱方式和未来几年机会点。',
    action: '去事业篇',
    path: '/career',
    background: 'linear-gradient(145deg, rgba(255, 247, 232, 0.98) 0%, rgba(248, 242, 255, 0.95) 100%)',
    border: '1px solid rgba(212, 175, 106, 0.24)',
    titleColor: '#47311d',
    actionColor: '#b8935d',
    descColor: '#6f675f',
  },
  {
    key: 'hepan',
    title: '合盘',
    desc: '想看你和另一个人的关系模式、相处节奏和深层拉扯，可以直接进去。',
    action: '去合盘',
    path: '/hepan',
    background: 'linear-gradient(145deg, rgba(244, 247, 255, 0.98) 0%, rgba(236, 244, 255, 0.95) 100%)',
    border: '1px solid rgba(102, 126, 234, 0.22)',
    titleColor: '#2e4e87',
    actionColor: '#5e7ee6',
    descColor: '#61708d',
  },
  {
    key: 'vedic',
    title: '印度占星',
    desc: '从本命盘、分盘、大运与流年，完整梳理你的人生结构和当前阶段。',
    action: '去印度占星',
    path: '/vedic',
    background: 'linear-gradient(145deg, rgba(252, 245, 255, 0.98) 0%, rgba(243, 238, 255, 0.95) 100%)',
    border: '1px solid rgba(137, 104, 184, 0.24)',
    titleColor: '#5d3f8c',
    actionColor: '#8362ad',
    descColor: '#70667f',
  },
  {
    key: 'talent-kid',
    title: '孩子天赋',
    desc: '如果你更关心孩子适合什么方向、怎么培养，可以直接进入孩子天赋专题。',
    action: '去孩子天赋',
    path: '/talent-kid',
    background: 'linear-gradient(145deg, rgba(255, 250, 239, 0.98) 0%, rgba(255, 244, 222, 0.95) 100%)',
    border: '1px solid rgba(224, 169, 75, 0.24)',
    titleColor: '#7a5318',
    actionColor: '#c48b2c',
    descColor: '#7a6a54',
  },
];

export const TopicHubPage = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const previousTitle = document.title;
    document.title = siteConfig.isPaidMode ? '有数｜专题选择' : '专题选择';
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <ConfigProvider locale={zhCN}>
      <div className="app-container">
        <div className="app-layout">
          <div className="center-content">
            <div style={{ width: '100%', maxWidth: '900px' }}>
              <div className="form-card" style={{ padding: '32px 28px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px', marginBottom: '24px' }}>
                  <div>
                    {siteConfig.isPaidMode && <div style={{ color: '#8a6a3d', fontSize: '30px', lineHeight: 1.1, fontWeight: 700, letterSpacing: '0.08em', marginBottom: '10px' }}>
                      有数
                    </div>}
                    <div style={{ color: '#73707a', fontSize: '15px', lineHeight: 1.8, maxWidth: '360px' }}>
                      先选你现在最想看的主题，我们再往下走。
                    </div>
                  </div>
                  <Button onClick={() => navigate(siteConfig.isPaidMode ? '/lite' : '/')} style={{ borderRadius: '999px' }}>
                    {siteConfig.isPaidMode ? '返回说明书' : '返回首页'}
                  </Button>
                </div>

                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                  <h1
                    className="form-title"
                    style={{
                      fontSize: '28px',
                      marginBottom: '10px',
                      background: 'linear-gradient(135deg, #8a6a3d 0%, #b8935d 55%, #d4af6a 100%)',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      animation: 'none',
                    }}
                  >
                    选择你要进入的专题
                  </h1>
                  <p style={{ margin: 0, color: '#5b6472', fontSize: '16px', lineHeight: 1.8 }}>
                    事业、关系、孩子天赋和印度占星，都可以单独展开看得更细。
                  </p>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '14px' }} className="topic-hub-grid">
                  {TOPIC_CARDS.map((card) => (
                    <div
                      key={card.key}
                      onClick={() => navigate(card.path)}
                      style={{
                        padding: '20px 20px 18px',
                        borderRadius: '18px',
                        background: card.background,
                        border: card.border,
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                      }}
                    >
                      <div style={{ fontSize: '20px', fontWeight: 700, color: card.titleColor, marginBottom: '10px' }}>
                        {card.title}
                      </div>
                      <div style={{ fontSize: '13px', color: card.descColor, lineHeight: 1.8, minHeight: '72px', marginBottom: '12px' }}>
                        {card.desc}
                      </div>
                      <div style={{ color: card.actionColor, fontSize: '14px', fontWeight: 600 }}>
                        {card.action} →
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
};
